import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";

export const initCtaSlider = (): void => {
  const sliders = document.querySelectorAll<HTMLElement>(".cta-slider .swiper");

  if (sliders.length === 0) {
    return;
  }

  sliders.forEach((sliderElement) => {
    // Select pagination strictly relative to this container
    const paginationEl = sliderElement.querySelector<HTMLElement>(
      ".cta-slider__pagination",
    );

    new Swiper(sliderElement, {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
    });
  });

  console.log("[CtaSlider] Scoped Swiper instances initialized.");
};
